import {HttpRequest,HttpMethod} from "./http";

class PackingProvider extends HttpRequest {

	// CRUD Packing
	PackingCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/packings`,params );
	}

	PackingList(params) {
		return this.request(HttpMethod.Get,`/api/v1/packings`,params );
	}

	PackingDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/packings/${id}`);
	}

	PackingShipping(params) {
		return this.request(HttpMethod.Post,`/api/v1/packings/print` ,params);
	}

	PackingGetDocument(params) {
		return this.request(HttpMethod.Get,`/api/v1/packings/print` ,params);
	}

	PickupItemAdd(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/verify/createoradd` ,params);
	}

	PickupItemRemove(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/verify/remove` ,params);
	}

	ShippingClose(params) {
		return this.request(HttpMethod.Post,`/api/v3/packings/verify/close` ,params);
	}

	ReturnCreate(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/return/create` ,params);
	}

	ReturnClose(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/return/close` ,params);
	}


	AdminPickupItemAdd(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/adminverify/createoradd` ,params);
	}

	AdminPickupItemClear(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/adminverify/delete` ,params);
	}

	AdminShippingClose(params) {
		return this.request(HttpMethod.Post,`/api/v3/packings/adminverify/close` ,params);
	}


}

export default PackingProvider